module.exports = __webpack_public_path__ + "img/fin_15_永远闭眼.d66192cf.jpg";